import PageContainer from '@/common/components/PageContainer'
import { useGameTypeSelector } from '@/common/hooks/useGameTypeSelector'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { PermissionType } from '@/common/types'
import useQueryGetGameList from '@/modules/game/api/hooks/useQueryGetGameList'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import GameListListing from '@/modules/game/components/GameList/components/GameListListing'
import withUserPermission from '@/common/components/WithUserPermission'

type GameType = 'SLOT' | 'CASINO' | 'LOTTO' | 'SPORT' | 'FISHING' | 'POPULAR'

export function GameListPage() {
	const { gameType, popular } = useGameTypeSelector()
	const { pageSize, currentPage, searchQuery, selectedQuery } =
		useTablePagination()

	const payload = {
		skip: (currentPage - 1) * pageSize,
		take: pageSize,
		type: (gameType.gameType as GameType) || undefined,
		isPopular: popular || undefined,
		name: searchQuery,
		providerName: selectedQuery,
	}
	const { data, isLoading, refetch } = useQueryGetGameList(payload)

	return (
		<PageContainer>
			<GameListListing
				data={data?.data || []}
				isLoading={isLoading}
				total={data?.total || 0}
				refetch={refetch}
			/>
		</PageContainer>
	)
}

const GuardedGameListPage = withUserPermission(GameListPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_GAME],
})

export default GuardedGameListPage
